module.exports = __webpack_public_path__ + "media/images/sample_img03-c5f467cc9d047925890f01d67ba29382.png";